export type FinanceComparisonMethod = {
  upfrontCost: number;
  baseInterestRate: number;
  savingsPercentage: number;
  annualSavings: number;
  lifetimeCostTotal: number;
  lifetimeCostWeekly: number;
  termMonths: number;
};

export type FinanceComparison = {
  novated: FinanceComparisonMethod;
  cash: FinanceComparisonMethod;
  homeloan: FinanceComparisonMethod;
  carloan: FinanceComparisonMethod;
};

export const FinanceMethodLabelMap: Record<keyof FinanceComparison, string> = {
  novated: "Novated",
  cash: "Cash",
  homeloan: "Home Loan",
  carloan: "Car Loan",
};

export type FinanceComparisonItem = {
  method: keyof FinanceComparison;
  upfrontCost: number;
  baseInterestRate: number;
  savingsPercentage: number;
  annualSavings: number;
  lifetimeCostTotal: number;
  lifetimeCostWeekly: number;
  termMonths: number;
  summary: string;
};

export const CriteriaLabelMap: Record<keyof FinanceComparisonItem, string> = {
  method: "",
  upfrontCost: "Upfront Cost",
  baseInterestRate: "Base Interest %^",
  annualSavings: "Annual Tax Savings",
  savingsPercentage: "Tax Savings %",
  lifetimeCostTotal: "Total Lifetime Cost",
  lifetimeCostWeekly: "Weekly Lifetime Cost",
  termMonths: "Term",
  summary: "Summary",
};
